import styled, { css } from "styled-components";
import { IoMdArrowDropdown, IoMdArrowDropright } from "react-icons/io";

interface CollectionProps {
  showFilters: boolean;
}

export const FilterDetailsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: none;

  width: 100%;
  height: 3rem;
  padding: 0.75rem 1rem;

  span {
    font-size: ${(props) => props.theme.fontSize.SM};
    font-weight: ${(props) => props.theme.fontWeight.Semibold};
    color: ${(props) => props.theme.colors["black-925"]};

    margin-left: 0.25rem;
  }

  svg {
    color: ${(props) => props.theme.colors["gray-800"]};
  }
`;

export const FilterContainer = styled.div`
  display: flex;
  align-items: center;

  padding: 1.5rem 0;

  border-bottom: 1px solid ${(props) => props.theme.colors["gray-400"]};

  svg {
    cursor: pointer;
    margin-right: 0.5rem;
    color: ${(props) => props.theme.colors["gray-800"]};
  }

  span {
    width: 25%;
  }

  div {
    margin-right: 1rem;
  }

  input {
    font-size: ${(props) => props.theme.fontSize.XXS};
    font-family: ${(props) => props.theme.fontFamily.Roboto};
    color: ${(props) => props.theme.colors["black-925"]};

    padding: 0.5rem;
    border-radius: 4px;
    border: 1px solid ${(props) => props.theme.colors["gray-400"]};

    background-color: ${(props) => props.theme.colors.white};

    margin-right: 1.5rem;
  }
`;

export const FilterCollectionContainer = styled.div<CollectionProps>`
  @media (max-width: ${(props) => props.theme.responsiveDesign.sm}) {
    width: 100%;
  }
`;

export const FilterCollection = styled.button<CollectionProps>`
  padding: 1rem 0;
  width: 100%;
  background: transparent;
  border: transparent;

  ${(props) =>
    props.showFilters &&
    css`
      border-bottom: transparent;
    `}

  @media (max-width: ${(props) => props.theme.responsiveDesign.sm}) {
    padding: 0 0 1rem;
  }
`;

export const CollectionIndicator = styled.div<CollectionProps>`
  display: flex;
  gap: 1rem;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid ${(props) => props.theme.colors["gray-400"]};

  & > span {
    margin-left: auto;
    background-color: ${(props) => props.theme.colors["blue-150"]};
    padding: 4px 15px;
    border-radius: ${(props) => props.theme.borderRadius.XXLG};
    margin-bottom: 0.375rem;

    color: ${(props) => props.theme.colors["blue-600"]};
    font-weight: ${(props) => props.theme.fontWeight.Bold};
  }

  & > p {
    font-size: ${(props) => props.theme.fontSize.XXS};
    color: ${(props) => props.theme.colors["gray-950"]};
    font-weight: ${(props) => props.theme.fontWeight.Bold};
    text-transform: capitalize;
    margin-bottom: 0.375rem;
  }
`;

export const ReduceArrowIcon = styled(IoMdArrowDropdown).attrs({
  size: 24,
})`
  cursor: pointer;
  margin-bottom: 0.375rem;
  color: ${(props) => props.theme.colors["black-925"]};
`;

export const ExpandArrowIcon = styled(IoMdArrowDropright).attrs({
  size: 24,
})`
  cursor: pointer;
  margin-bottom: 0.375rem;
  color: ${(props) => props.theme.colors["black-925"]};
`;
